import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'

/** Router context: the query client, so loaders can prefetch before a component renders. */
export interface RouterContext {
  queryClient: QueryClient
}

/**
 * No app chrome here: the shell belongs to the authenticated /app layout
 * (src/routes/app/route.tsx). The landing page renders bare on purpose.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: () => (
    <div className="p-8">
      <h1 className="text-lg font-medium">Page not found</h1>
      <Link to="/" className="text-sm underline underline-offset-4">
        Back to home
      </Link>
    </div>
  ),
})
